export const formatCount = (value: number): string => {
  if (value >= 10000) {
    const w = value / 10000;
    return `${w.toFixed(w >= 10 ? 0 : 1)}万`;
  }
  return String(value);
};

export const toNextTimestamp = (time: string): number => {
  const [hour, minute] = time.split(':').map((part) => Number(part));
  const date = new Date();
  date.setHours(hour, minute, 0, 0);
  if (date.getTime() <= Date.now()) {
    date.setDate(date.getDate() + 1);
  }
  return date.getTime();
};

export const toTodayTimestamp = (time: string): number => {
  const [hour, minute] = time.split(':').map((part) => Number(part));
  const date = new Date();
  date.setHours(hour, minute, 0, 0);
  return date.getTime();
};

const WEEKDAYS = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];

export const todayLabel = (): string => {
  const date = new Date();
  return `${date.getFullYear()} 年 ${date.getMonth() + 1} 月 ${date.getDate()} 日`;
};

export const todayWeekday = (): string => WEEKDAYS[new Date().getDay()];

export const weekdayOf = (dateLabel: string): string => {
  const [month, day] = dateLabel.split('-').map((part) => Number(part));
  const year = new Date().getFullYear();
  return WEEKDAYS[new Date(year, month - 1, day).getDay()];
};

export const statusText: Record<string, string> = {
  live: '正在直播',
  upcoming: '即将开始',
  ended: '已结束',
};